import { withStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import { TheCycleverseTheme } from "src/theme";
import { OverridableComponent } from "@material-ui/core/OverridableComponent";
import { SliderTypeMap } from "@material-ui/core/Slider/Slider";

const CystomSlider = withStyles((theme: TheCycleverseTheme) => ({
  root: {
    marginTop: 16,
    color: theme.unflashyColor,
    height: 2,
    padding: "15px 0",
  },
  thumb: {
    height: 38,
    width: 38,
    border: `1px solid ${theme.unflashyColor}`,
    backgroundColor: "#fff",
    marginTop: -19,
    marginLeft: -19,
    backgroundImage: "url(/images/schrittlaenge-auswaehlen.svg)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 20px)",
    top: -28,
    "& *": {
      background: "#fff", //'transparent',
      color: "#000",
      fontWeight: 500,
      fontSize: 16,
    },
  },
  track: {
    height: 4,
    // NOTE: this is the fallback for old browsers if the next one
    // doesn't make sense to them
    // background: theme.highlightGradientBg,
    backgroundColor: "#bfbfbf",
    // eslint-disable-next-line no-dupe-keys
    // @ts-ignore-next-line
    // background: props => props?.isnotactive === 'isNotActive' ? theme.sliderDisabled : theme.highlightGradient,
  },
  rail: {
    height: 3,
    // opacity: 0.5,
    backgroundColor: "#bfbfbf",
  },
  marks: {
    backgroundColor: "#CCC",
    // height: 10,
    // width: "50px",
    // padding: "20px",
    marginTop: -3,
  },

  mark: {
    height: 10,
    width: 10,
    borderRadius: "40%",
    marginTop: -3,
  },

  markActive: {
    // opacity: 2,
    // backgroundColor: "currentColor",
    background: "#ccc",
    width: 10,
    height: 10,
    borderRadius: "40%",
    marginTop: -3,
  },
}))(Slider);

type SliderTypeMapWithNotActive = {
  isnotactive?: boolean;
};
export const BreakPointsSlider: OverridableComponent<SliderTypeMap<SliderTypeMapWithNotActive>> = (props) => {
  return (
    <div style={{ marginLeft: 16, marginRight: 16 }}>
      <CystomSlider {...props} isnotactive={props?.isnotactive ? "isNotActive" : "active"} />
    </div>
  );
};
